//import Vue from 'vue';
//import AndroidPermissions from '../services/AndroidPermissions.js';
//import { pushNotifications } from '../services/PushNotifications.js';
//import { statusBar } from '../services/StatusBar.js';

class CordovaInit{
    init(){
        
        // return device ready promise
        return Promise.resolve();
    }

    // wait for async promise to resolve
    

    isMobile(){

        return false
        

        /*
        if (navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)/i))
        {
            return true;
        }
        return false;
        */
    }
/*
   handlePermissions(){
       

    // probabely need to check api level >28 for WRITE_EXTERNAL
    var permissions = new AndroidPermissions(["READ_EXTERNAL_STORAGE","WRITE_EXTERNAL_STORAGE"]);
      permissions.check().then(
        ()=>{
          //alert("opermission granted!!")
          //Vue.$toaster.toast('ok')
          
        },
        (err)=>{
          
          Vue.$toaster.toast('android permissions error: '+err)
        }
      )
    }
*/
    doInappReview(){
        
    }


    // only called on mobile
    configureCordovaPlugins(){
        // maybe setup pushontes here
    }
    
}

export let cordovaInit = new CordovaInit();